export var isInIframe = function () {
    return window !== top;
};
//# sourceMappingURL=iframeDetector.js.map